function asNumberString(value) {
    const normalized = Number(value);
    if (!Number.isFinite(normalized)) {
        return '';
    }
    return String(value);
}

function buildNutritiousDiningProcurementSummaryRows(procurementDateDetail) {
    const procurement = procurementDateDetail && procurementDateDetail.procurement;
    if (!procurement || Array.isArray(procurement) || typeof procurement !== 'object') {
        return [];
    }

    return [
        { label: '采购日期', value: String(procurement.procurementDate || '').trim() },
        { label: '开餐人员数量', value: asNumberString(procurement.diningPeopleCount) },
        { label: '学生人数', value: asNumberString(procurement.studentCount) },
        { label: '补助标准', value: asNumberString(procurement.subsidyStandard) },
        { label: '采购总额', value: asNumberString(procurement.procurementAmount) },
        { label: '补助金额', value: asNumberString(procurement.subsidyAmount) },
        { label: '采购超支金额', value: asNumberString(procurement.overspendAmount) },
        { label: '补助结余金额', value: asNumberString(procurement.balanceAmount) },
        { label: '采购员', value: String(procurement.purchaser || '').trim() },
        { label: '验收员', value: String(procurement.inspector || '').trim() },
        { label: '供应商', value: String(procurement.supplier || '').trim() },
        { label: '联系方式', value: String(procurement.contact || '').trim() },
    ];
}

function buildNutritiousDiningProcurementDetailRows(procurementDateDetail) {
    const details = procurementDateDetail && procurementDateDetail.details;
    if (!Array.isArray(details)) {
        return [];
    }

    return details
        .map((detail) => {
            if (!detail || typeof detail !== 'object') {
                return null;
            }

            const name = String(detail.name || '').trim();
            if (!name) {
                return null;
            }

            return {
                name,
                unit: String(detail.unit || '').trim(),
                qtyText: asNumberString(detail.quantity),
                priceText: asNumberString(detail.price),
                amountText: asNumberString(detail.totalAmount),
            };
        })
        .filter(Boolean);
}

module.exports = {
    buildNutritiousDiningProcurementSummaryRows,
    buildNutritiousDiningProcurementDetailRows,
};
